import { useMutation } from '@tanstack/react-query';
import type { CandidateEndpointProfileUpdateRequest } from '../types/CandidateEndpoint';

export default function useUpdateCandidateEndpointsProfile() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async ({
      title,
      status,
      is_show_job_post,
      is_show_process,
      is_show_uploader,
      is_login_required,
      login_id,
      password,
      candidateProfileId,
    }: CandidateEndpointProfileUpdateRequest) => {
      const response = await fetch(`/agent/api/candidate_endpoints/${candidateProfileId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify({
          candidate_endpoint: {
            title,
            status,
            is_show_job_post,
            is_show_process,
            is_show_uploader,
            is_login_required,
            login_id,
            password,
          },
        }),
      });
      const data = await response.json();
      return data;
    },
  });
}
